<!--
  Ordini parziali — Dettagli (assegnazione).
  Redesigned 2026-06-15 (v2.8.0, Phase 1.5 Chunk E.2).

  Drops kendo-dialog + kendo-formfield + kendo-label + 4× kendo-combobox
  + kendo-dropdownlist (× N prodotti) + kendoTextBox (× N) + kendo-formerror
  + ~15 inline styles position:fixed/width!important
  (79 kendo refs → 0).

  Pattern Diakonix modale XL (mirror ordini-da-firmare-detaggli):
    - Backdrop z-index 2000 (sopra sidebar 1001)
    - Sticky header con titolo + chip viola "Parziale" + close
    - Body 2 colonne (info readonly + assegnazione editable),
      stacked < 900px
    - Sezione full-width "Prodotti picking" con toggle Seleziona/
      Deseleziona tutti + lista card-row con select quantità prelevata
    - Footer con "Annulla" + "🚀 Pronto per l'operatore"

  Sub-modale preserved as-is:
    - app-product-detail (visualizza posizione magazzino del prodotto)
-->

@if (isAssegnaOn) {
  <div class="modal-backdrop" (click)="goBack()">
    <div
      class="modal modal--xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="parziali-det-title"
      (click)="$event.stopPropagation()"
    >

      <!-- ─── Header ────────────────────────────────────────────── -->
      <header class="modal__header">
        <h2 id="parziali-det-title" class="modal__title">
          <span aria-hidden="true">📦</span>
          Assegnazione ordine

          @if (orderNew?.or_order_number) {
            <span class="modal__title-tag">n° {{ orderNew.or_order_number }}</span>
          }

          <span class="status-chip status-chip--partial" title="Ordine con consegna parziale">
            Parziale
          </span>
        </h2>

        <button
          type="button"
          class="modal-close"
          (click)="goBack()"
          aria-label="Chiudi"
        >×</button>
      </header>

      <!-- ─── Body ──────────────────────────────────────────────── -->
      <div class="modal__body">

        @if (loading) {
          <div class="loading-card" aria-live="polite">
            <div class="loading-card__spinner" aria-hidden="true"></div>
            <p>Caricamento ordine…</p>
          </div>
        } @else if (orderNew) {

          <form
            class="form-grid"
            [formGroup]="assignOrderForm"
            (ngSubmit)="submit()"
          >

            <!-- ─── Top row: 2 columns ──────────────────────────── -->
            <div class="form-cols">

              <!-- Col 1 — Info ordine (readonly) -->
              <section class="info-card">
                <header class="info-card__header">
                  <h3 class="info-card__title">📋 Dati ordine</h3>
                </header>

                <div class="info-grid">
                  <div class="info-field">
                    <span class="info-field__label">N° Ordine</span>
                    <span class="info-field__value info-field__value--strong">
                      {{ orderNew.or_order_number || '—' }}
                    </span>
                  </div>

                  <div class="info-field">
                    <span class="info-field__label">Data ordine</span>
                    <span class="info-field__value">{{ formattedDate }}</span>
                  </div>

                  <div class="info-field info-field--full">
                    <span class="info-field__label">Cliente</span>
                    <span class="info-field__value">
                      {{ orderNew.or_customer || '—' }}
                    </span>
                  </div>

                  <div class="info-field info-field--full">
                    <span class="info-field__label">Indirizzo di consegna</span>
                    <span class="info-field__value">
                      {{ orderNew.or_shipping_address || '—' }}
                    </span>
                  </div>

                  <div class="info-field">
                    <span class="info-field__label">Città</span>
                    <span class="info-field__value">
                      {{ orderNew.or_shipping_city || '—' }}
                    </span>
                  </div>

                  <div class="info-field">
                    <span class="info-field__label">CAP</span>
                    <span class="info-field__value">
                      {{ orderNew.or_shipping_zip || '—' }}
                    </span>
                  </div>

                  <div class="info-field">
                    <span class="info-field__label">Provincia</span>
                    <span class="info-field__value">
                      {{ orderNew.or_shipping_prov || '—' }}
                    </span>
                  </div>

                  <div class="info-field info-field--full">
                    <span class="info-field__label">Nazione</span>
                    <span class="info-field__value">
                      {{ orderNew.or_shipping_country || '—' }}
                    </span>
                  </div>

                  @if (orderNew.or_note) {
                    <div class="info-field info-field--full">
                      <span class="info-field__label">Note ordine</span>
                      <span class="info-field__value">{{ orderNew.or_note }}</span>
                    </div>
                  }
                </div>
              </section>

              <!-- Col 2 — Assegnazione (editable) -->
              <section class="info-card">
                <header class="info-card__header">
                  <h3 class="info-card__title">🎯 Assegnazione</h3>
                </header>

                <div class="info-grid info-grid--form">

                  <!-- Operatore -->
                  <label class="field field--full">
                    <span class="field__label">
                      Operatore <span class="field__required" aria-hidden="true">*</span>
                    </span>
                    <select
                      class="field__input"
                      formControlName="or_assigned_id"
                      [class.field__input--invalid]="
                        assignOrderForm.get('or_assigned_id')?.touched &&
                        assignOrderForm.get('or_assigned_id')?.invalid
                      "
                    >
                      <option [ngValue]="''">— seleziona operatore —</option>
                      @for (w of workers; track w.account_id) {
                        <option [ngValue]="w.account_id">{{ w.full_name }}</option>
                      }
                    </select>
                    @if (
                      assignOrderForm.get('or_assigned_id')?.touched &&
                      assignOrderForm.get('or_assigned_id')?.invalid
                    ) {
                      <span class="field__error">Operatore obbligatorio</span>
                    }
                  </label>

                  <!-- Priorità -->
                  <label class="field">
                    <span class="field__label">
                      Priorità <span class="field__required" aria-hidden="true">*</span>
                    </span>
                    <select
                      class="field__input"
                      formControlName="or_order_priority_cod"
                      [class.field__input--invalid]="
                        assignOrderForm.get('or_order_priority_cod')?.touched &&
                        assignOrderForm.get('or_order_priority_cod')?.invalid
                      "
                    >
                      <option [ngValue]="''">— seleziona priorità —</option>
                      @for (p of priorityOptions; track p.tab_priority_order_cod) {
                        <option [ngValue]="p.tab_priority_order_cod">
                          {{ p.tab_priority_order_desc }}
                        </option>
                      }
                    </select>
                    @if (
                      assignOrderForm.get('or_order_priority_cod')?.touched &&
                      assignOrderForm.get('or_order_priority_cod')?.invalid
                    ) {
                      <span class="field__error">Priorità obbligatoria</span>
                    }
                  </label>

                  <!-- Corriere -->
                  <label class="field">
                    <span class="field__label">Corriere</span>
                    <select class="field__input" formControlName="or_carrier_id">
                      <option [ngValue]="''">— seleziona corriere —</option>
                      @for (c of carriers; track c.carrier_id) {
                        <option [ngValue]="c.carrier_id">{{ c.carrier_desc }}</option>
                      }
                    </select>
                  </label>

                  <!-- Note assegnazione -->
                  <label class="field field--full">
                    <span class="field__label">Note assegnazione</span>
                    <input
                      type="text"
                      class="field__input"
                      formControlName="or_note"
                      placeholder="—"
                      maxlength="250"
                    />
                  </label>
                </div>
              </section>
            </div>

            <!-- ─── Prodotti picking (full-width) ────────────────── -->
            <section class="info-card picking-card">
              <header class="info-card__header picking-card__header">
                <h3 class="info-card__title">
                  📦 Elenco prodotti
                  <span class="picking-card__count">{{ productsNew.length }}</span>
                </h3>

                @if (productsNew.length > 0) {
                  <button
                    type="button"
                    class="btn btn--ghost btn--sm"
                    (click)="selectAllProducts()"
                  >
                    @if (allSelected) {
                      <span aria-hidden="true">⛔</span> Deseleziona tutti
                    } @else {
                      <span aria-hidden="true">✅</span> Seleziona tutti
                    }
                  </button>
                }
              </header>

              @if (productsNew.length === 0) {
                <div class="picking-empty">
                  <span class="picking-empty__icon" aria-hidden="true">📭</span>
                  <p class="picking-empty__msg">Nessun prodotto in questo ordine.</p>
                </div>
              } @else {
                <ul class="picking-list" role="list">
                  @for (prod of productsNew; track prod.op_code; let i = $index) {
                    <li
                      class="picking-row"
                      [class.picking-row--checked]="prod.op_checked"
                    >
                      <button
                        type="button"
                        class="picking-row__toggle"
                        (click)="togglePicked(i)"
                        [attr.aria-pressed]="prod.op_checked"
                        [attr.aria-label]="prod.op_checked ? 'Deseleziona prodotto' : 'Seleziona prodotto'"
                      >
                        @if (prod.op_checked) {
                          <span class="picking-row__check picking-row__check--on" aria-hidden="true">✓</span>
                        } @else {
                          <span class="picking-row__check" aria-hidden="true"></span>
                        }
                      </button>

                      <div class="picking-row__body" (click)="togglePicked(i)">
                        <span class="picking-row__code">{{ prod.op_code }}</span>
                        <span class="picking-row__desc">{{ prod.op_description }}</span>
                      </div>

                      <div class="picking-row__qty" (click)="$event.stopPropagation()">
                        <label class="picking-row__qty-label">Prelev.</label>
                        <select
                          class="picking-row__qty-select"
                          [ngModel]="prod.op_qta_picked"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="updateQuantity($event, i)"
                          [class.picking-row__qty-select--overflow]="
                            prod.op_qta > prod.op_qta_ordered
                          "
                          [attr.title]="'Massimo ordinato: ' + prod.op_qta_ordered"
                        >
                          @for (n of qtyOptions[prod.op_code]; track n) {
                            <option [ngValue]="n">{{ n }} / {{ prod.op_qta_ordered }}</option>
                          }
                        </select>

                        <button
                          type="button"
                          class="picking-row__info"
                          (click)="productDetails(prod)"
                          title="Dettagli prodotto"
                          aria-label="Dettagli prodotto"
                        >ℹ️</button>
                      </div>
                    </li>
                  }
                </ul>
              }
            </section>

            @if (assignOrderForm.invalid && assignOrderForm.touched) {
              <p class="form-warning" role="alert">
                ⚠️ Assicurati che tutti i campi obbligatori siano compilati.
              </p>
            }
          </form>
        }
      </div>

      <!-- ─── Footer ────────────────────────────────────────────── -->
      @if (!loading && orderNew) {
        <footer class="modal__footer">
          <button
            type="button"
            class="btn btn--ghost"
            (click)="goBack()"
            [disabled]="sending"
          >Annulla</button>

          <button
            type="button"
            class="btn btn--primary"
            (click)="submit()"
            [disabled]="!isReady"
          >
            @if (sending) {
              <span class="btn__spinner" aria-hidden="true"></span>
              Invio in corso…
            } @else {
              <span aria-hidden="true">🚀</span>
              Pronto per l'operatore
            }
          </button>
        </footer>
      }
    </div>
  </div>
}

<!-- ─── Sub-modale prodotto (preserved as-is) ─────────────────── -->
@if (closeServ.isProdopen && clickedProductId !== null) {
  <app-product-detail
    [opened]="closeServ.isProdopen"
    [product_id]="clickedProductId"
  ></app-product-detail>
}
